export default ".header-actions {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 15px;\n}";